/**
 * Created by saeed on 10/02/2018.
 */
(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ExportService', ExportService);

    ExportService.$inject = ['$resource', 'DateUtils', 'ENV'];

    function ExportService($resource, DateUtils, ENV) {


        var export_excel_orderbag_list_by_service = function (serviceid, fromdate, todate, status) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/export_excel_orderbag_list_by_service?' + 'status=' + status + '&serviceid=' + serviceid + '&fromdate=' + DateUtils.convertToISOString(fromdate) + '&todate=' + DateUtils.convertToISOString(todate);
            return $resource(resourceUrl, {});
        }


        var download_excel_file = function (request, onSuccess, onError) {

            request.get({}, function (result) {
                var dlfile = ENV.API_BASE_URL + "api/client/downloadFile/" + result.filename;
                result.dllink = dlfile;
                if (onSuccess) {
                    onSuccess(result);
                }
                setTimeout(function () {
                    document.location.href = dlfile;
                }, 500);


            }, function (error) {
                if (onError)
                    onError(error);
            });
        }
        var download_excel_file_by_name = function (result, onSuccess) {
            var dlfile = ENV.API_BASE_URL + "api/client/downloadFile/" + result.filename;
            setTimeout(function () {
                if (onSuccess) {
                    onSuccess(dlfile);
                }
                document.location.href = dlfile;


            }, 500);

            //request.get({},function (result) {
            //    var dlfile="api/client/downloadFile/"+result.filename;
            //    result.dllink=dlfile;
            //    if(onSuccess) {
            //        onSuccess(result);
            //    }
            //
            //
            //
            //},function(error){
            //    if(onError)
            //        onError(error);
            //});
        }
        var export_excel_financial_by_customer = function (customerid, fromdate, todate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/export_excel_financial_by_customer?' + 'customerid=' + customerid + '&fromdate=' + DateUtils.convertToISOString(fromdate) + '&todate=' + DateUtils.convertToISOString(todate);
            return $resource(resourceUrl, {});
        }
        var export_excel_from_storedProcedure = function (spname) {
            //  var config={params:parameters};

            //  var resourceUrl = 'api/client/export_excel_sp?' + 'spName=' + spname  + '&parameters=' + JSON.stringify(config) ;
            var resourceUrl = ENV.API_BASE_URL + 'api/export_excel_sp/' + spname;
            return $resource(resourceUrl, {});
        }

        var export_company_form_data_list = function (formId, customerid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/export_excel_company_form_data_list?' + 'formId=' + formId + '&customerId=' + customerid;
            return $resource(resourceUrl, {});
        }
        return {
            export_excel_orderbag_list_by_service: export_excel_orderbag_list_by_service,
            download_excel_file: download_excel_file,
            export_excel_financial_by_customer: export_excel_financial_by_customer,
            export_excel_from_storedProcedure: export_excel_from_storedProcedure,
            download_excel_file_by_name: download_excel_file_by_name,
            export_company_form_data_list: export_company_form_data_list
        };


    }


})();
